<template>
	<PropertyRow :label="label" :dd-class="ddClass" :dt-class="dtClass">
		<template #actions>
			<DataSourceButton
				v-for="(source, index) in dataSources"
				:key="index"
				:value="source.value"
				:current-value="modelValue"
				:source="source.source"
				:transformer="source.transformer"
				:tooltip="source.tooltip"
				:on-apply="() => handleApply(source)"
			/>
		</template>

		<AppFieldNumeric
			v-if="isNumeric(valueType)"
			v-model="modelValue as number | undefined"
			:value-type
			:precision="
				precision !== undefined
					? precision
					: valueType === ValueType.Percentage
						? 2
						: 0
			"
			:grouping="valueType === ValueType.Currency"
			:prefix="valueType === ValueType.Currency ? '€' : ''"
			:suffix="valueType === ValueType.Percentage ? '%' : ''"
			:wrapper-class="inputClass"
		/>
		<AppFieldDate
			v-else-if="valueType === ValueType.Date"
			v-model="modelValue as string | undefined"
			:class="inputClass"
		/>
		<InputText
			v-else
			v-model="modelValue"
			:class="inputClass"
			:value-type="valueType"
		/>
	</PropertyRow>
</template>

<script setup lang="ts" generic="T extends ValueType">
import { ValueType } from "@/enums/ValueType";
import type { DataSource } from "./dataSources";
import { isNumeric } from "@/helpers/valueTypeHelpers";
import type { ValueTypeToType } from "@/models/domain/ValueTypeToType";

defineProps<{
	label: string;
	valueType: T;
	precision?: number;
	inputClass?: string;
	ddClass?: string;
	dtClass?: string;
	dataSources?: DataSource[];
}>();

const modelValue = defineModel<ValueTypeToType<T>>();

function handleApply(source: DataSource) {
	source.onApply?.(source.value);
}
</script>
